import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { api } from "../lib/api";

export default function WarrantyBoxSheetPage() {
  const { id } = useParams();
  const [w, setW] = useState(null);
  const [error, setError] = useState(false);
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("kk_token")) { setAuthed(false); return; }
    api.get("/auth/me").then(() => setAuthed(true)).catch(() => setAuthed(false));
  }, []);

  useEffect(() => {
    if (!authed) return;
    api.get("/admin/warranties").then((r) => {
      const found = r.data.find((x) => x.id === id);
      if (found) {
        setW(found);
        setTimeout(() => window.print(), 700);
      } else setError(true);
    }).catch(() => setError(true));
  }, [authed, id]);

  if (authed === false) return <Navigate to="/admin/login" replace />;
  if (authed === null) return null;
  if (error) return <div className="p-10 text-center">Garantia nu a fost gasita.</div>;
  if (!w) return <div className="p-10 text-center text-neutral-500">Se incarca...</div>;

  const cancelled = w.status === "cancelled" || !!w.cancel_reason;
  const today = new Date().toLocaleDateString("ro-RO");
  const receivedDay = new Date(w.received_at).toLocaleDateString("ro-RO");
  const shippedDay = w.shipped_at ? new Date(w.shipped_at).toLocaleDateString("ro-RO") : today;

  return (
    <div data-testid="warranty-box-sheet-page" className="kk-print bg-white text-black min-h-screen">
      <style>{`
        @page { size: A4; margin: 10mm; }
        @media print {
          .no-print { display: none !important; }
          body { background: white !important; }
        }
        .kk-print { font-family: 'Outfit', sans-serif; }
        .kk-print h1, .kk-print h2, .kk-print .display { font-family: 'Anton', sans-serif; letter-spacing: -0.02em; }
      `}</style>

      <div className="no-print fixed top-4 right-4 flex gap-2 z-50">
        <button data-testid="print-btn" onClick={() => window.print()} className="bg-[#00E5FF] text-black font-semibold px-4 py-2 text-sm uppercase tracking-wider">Printeaza</button>
        <button data-testid="close-btn" onClick={() => window.close()} className="border border-neutral-400 text-neutral-700 px-4 py-2 text-sm uppercase tracking-wider">Inchide</button>
      </div>

      <div className="max-w-3xl mx-auto p-6">
        {/* Banda superioara */}
        <div className="bg-black text-white p-6 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-[#00E5FF] flex items-center justify-center text-black font-bold text-2xl display">K</div>
            <div>
              <div className="display text-2xl uppercase leading-none">TROTI-X SERVICE</div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] mt-1.5">Service autorizat garantii · trotinete-ieftine.ro</div>
            </div>
          </div>
          <div className="text-right">
            <div className="text-[10px] uppercase tracking-widest text-neutral-400">Garantie</div>
            <div className="display text-3xl text-[#00E5FF]">{w.warranty_number}</div>
          </div>
        </div>

        {/* Mesaj mare */}
        <div className="border-x-2 border-black px-6 py-5 text-center">
          <div className="display text-4xl uppercase leading-tight">
            Trotineta ta e <span className="text-[#00E5FF]">{cancelled ? "verificata" : "reparata"}</span> si vine spre tine!
          </div>
          <div className="text-sm text-neutral-600 mt-2">
            Mai jos gasesti raportul complet al interventiei efectuate in service-ul nostru.
          </div>
        </div>

        {/* Info produs + traseu */}
        <div className="border-2 border-black">
          <div className="grid grid-cols-3 divide-x-2 divide-black border-b-2 border-black">
            <div className="p-4">
              <div className="text-[9px] uppercase tracking-widest text-neutral-500">Client</div>
              <div className="font-bold text-lg leading-tight mt-1">{w.customer_name}</div>
            </div>
            <div className="p-4">
              <div className="text-[9px] uppercase tracking-widest text-neutral-500">Model</div>
              <div className="font-bold text-lg leading-tight mt-1">{w.scooter_model}</div>
              {w.serial_number && <div className="text-[10px] font-mono text-neutral-600 mt-0.5">SN: {w.serial_number}</div>}
            </div>
            <div className="p-4">
              <div className="text-[9px] uppercase tracking-widest text-neutral-500">Perioada in service</div>
              <div className="font-bold text-lg leading-tight mt-1">{receivedDay} → {shippedDay}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 divide-x-2 divide-black">
            <div className="p-4 flex items-center justify-between">
              <div>
                <div className="text-[9px] uppercase tracking-widest text-neutral-500">AWB intrare</div>
                <div className="font-mono font-bold text-lg">{w.awb_in}</div>
              </div>
              <div className="text-2xl text-neutral-300">→</div>
            </div>
            <div className="p-4 bg-neutral-100">
              <div className="text-[9px] uppercase tracking-widest text-neutral-500">AWB retur (acest colet)</div>
              <div className="font-mono font-bold text-lg">{w.awb_out || "—"}</div>
            </div>
          </div>
        </div>

        {/* Raport interventie */}
        <div className="mt-5">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-2">// Raport interventie</div>

          <div className="grid grid-cols-[24px_1fr] gap-x-3">
            <div className="flex flex-col items-center">
              <div className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center text-xs font-bold">1</div>
              <div className="w-0.5 flex-1 bg-neutral-300" />
            </div>
            <div className="pb-4">
              <div className="text-xs uppercase tracking-widest font-bold">Problema reclamata</div>
              <div className="text-sm text-neutral-800 mt-1 leading-relaxed whitespace-pre-wrap">{w.issue_description}</div>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-6 h-6 rounded-full bg-black text-white flex items-center justify-center text-xs font-bold">2</div>
              <div className="w-0.5 flex-1 bg-neutral-300" />
            </div>
            <div className="pb-4">
              <div className="text-xs uppercase tracking-widest font-bold">Constatare tehnica</div>
              <div className="text-sm text-neutral-800 mt-1 leading-relaxed whitespace-pre-wrap">{w.verdict_notes || "—"}</div>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-6 h-6 rounded-full bg-[#00E5FF] text-black flex items-center justify-center text-xs font-bold">3</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest font-bold">Rezolvare / Lucrari efectuate</div>
              <div className="text-sm text-neutral-800 mt-1 leading-relaxed whitespace-pre-wrap">{w.resolution || "—"}</div>
            </div>
          </div>
        </div>

        {/* Verdict */}
        <div className={`mt-5 border-2 p-4 flex items-center gap-4 ${cancelled ? "border-red-600 bg-red-50" : "border-green-600 bg-green-50"}`}>
          <div className={`display text-3xl ${cancelled ? "text-red-600" : "text-green-700"}`}>{cancelled ? "✗" : "✓"}</div>
          <div>
            <div className={`font-bold uppercase text-lg ${cancelled ? "text-red-600" : "text-green-700"}`}>
              {cancelled ? "Garantie ANULATA" : "Reparata pe garantie — fara costuri"}
            </div>
            {cancelled && w.cancel_reason && <div className="text-sm mt-0.5"><strong>Motiv:</strong> {w.cancel_reason}</div>}
            {!cancelled && <div className="text-sm text-neutral-600 mt-0.5">Interventia a fost acoperita integral de garantia trotinete-ieftine.ro.</div>}
          </div>
        </div>

        {/* Sfaturi + contact */}
        <div className="grid grid-cols-2 gap-4 mt-5">
          <div className="border border-neutral-300 p-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-2">// Sfaturi dupa service</div>
            <ul className="text-[11px] leading-relaxed space-y-1 text-neutral-800 list-disc pl-4">
              <li>Verifica presiunea in anvelope inainte de prima cursa.</li>
              <li>Incarca bateria complet inainte de utilizare.</li>
              <li>Nu expune trotineta la ploaie torentiala sau balti adanci.</li>
              <li>Strange periodic suruburile de la ghidon si punte.</li>
            </ul>
          </div>
          <div className="bg-black text-white p-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-2">// Ai intrebari?</div>
            <div className="text-sm font-bold">TROTI-X SERVICE</div>
            <div className="text-[11px] leading-relaxed text-neutral-300 mt-1">
              Bd. Liviu Rebreanu 104A, Timisoara<br />
              Tel: <span className="text-white font-bold">0743 110 277</span><br />
              L-V 9:00-17:00 · Sambata 9:00-14:00<br />
              Partener oficial: <span className="text-[#00E5FF]">trotinete-ieftine.ro</span>
            </div>
          </div>
        </div>

        {/* Footer multumire */}
        <div className="mt-5 bg-[#00E5FF] text-black p-4 text-center">
          <div className="display text-2xl uppercase">Multumim ca alegi trotinete-ieftine.ro!</div>
          <div className="text-xs mt-1 font-medium">Drum bun si kilometri multi! · Fisa emisa la {today} · {w.warranty_number}</div>
        </div>
      </div>
    </div>
  );
}
